import React, { useState, useEffect, useContext } from "react";
import { Link } from "react-router-dom";
import { Vehicle, Email, Closed, Noimage } from "../../common/imagePath";
import { AppContext } from "../../context/AppContext";
import EditOutlinedIcon from "@mui/icons-material/EditOutlined";
import DeleteForeverOutlinedIcon from "@mui/icons-material/DeleteForeverOutlined";
import CustomerSupplierDetailModel from "../Modal/CustomerSupplierDetailModel";
import CurrencySymbols from "../../common/CurrencySymbol";
import CustomerConfirm from "../Modal/CustomerConfirm";
// import { AppContext } from "../../context/AppContext";

function ReceivingCard({ data, onCancel, visible, callback }) {
  const { CurrencySymbol, FractionDigits } = useContext(AppContext);
  const [showEdit, setShowEdit] = useState(false);
  const [newData, setNewData] = useState(data);
  const [detailModel, setDetailModel] = useState({ Id: 0, Model: "" });
  const [showCustomerModal, setShowCustomerModal] = useState(false);
  const [CustomerPopup, setCustomerPopup] = useState(false);
  //accordian

  console.log(newData, "detailModel");
  console.log(detailModel, "detailModel");

  const [isAccordionOpen, setAccordionOpen] = useState(false);

  const toggleAccordion = () => {
    setAccordionOpen(!isAccordionOpen);
  };

  //////

  let supplierAddress =
    (newData?.Address1?.length > 0 ? newData?.Address1 + " " : "") +
    (newData?.Address2?.length > 0 ? newData?.Address2 + ", " : "") +
    (newData?.City?.length > 0 ? newData?.City + ", " : "") +
    (newData?.State?.length > 0 ? newData?.State + ", " : "") +
    (newData?.Country?.length > 0 ? newData?.Country + ", " : "") +
    (newData?.Zip > 0 ? newData?.Zip + "" : "");

  const [mailingAddress, setMailingAddress] = useState(
    data?.inputBilling ? data?.inputBilling : supplierAddress
  );
  const [valueOfInput, setValueOfInput] = useState(
    data?.inputBilling ? data?.inputBilling : supplierAddress
  );

  const { updateMail } = useContext(AppContext);

  useEffect(() => {
    setNewData(data);
    setMailingAddress(
      data?.inputBilling ? data?.inputBilling : supplierAddress
    );
  }, [data, supplierAddress]);

  const HandelCustomerSupplierDetailModel = () => {
    setDetailModel({
      Id: newData?.Id || newData?.SupplierId,
      Model:
        newData?.PayeeType === 0
          ? "supplier"
          : newData?.PayeeType === 1
          ? "customer"
          : "employee",
    });
    setShowCustomerModal(true);
  };

  const handleClick = () => {
    // setValueOfInput(mailingAddress);
    setValueOfInput(valueOfInput);
    setShowEdit(true);
  };

  const handleAddress = (e) => {
    setValueOfInput(e?.target?.value);
    // setAddValue(e.target.value);
    // setShowEdit(true);
    callback(e?.target?.value);
  };

  const AddAddress = (e) => {
    setValueOfInput(valueOfInput);

    setMailingAddress(valueOfInput);

    setShowEdit(false);

    // updateMail(valueOfInput)

    // callback(valueOfInput);
  };
  console.log(data, "data95==>");

  const handlecress = (e) => {
    if (e === "Ok") {
      onCancel();
    }
    setCustomerPopup(!CustomerPopup);
  };

  return (
    <>
      <div className="">
        <div>
          <div className="row">
            <div className="col-md-2">
              <img
                src={data.Image}
                onError={(e) => {
                  e.currentTarget.src = Noimage;
                }}
                //alt={props.Name}
                className="img-thumbnail rounded-circle"
                width="100px"
                height="105px"
              />
            </div>

            <div className="col-7">
              <div
                // data-bs-target="#CustomerSupplierDetailModel"
                // data-bs-toggle="modal"
                class="text-dark cursor-pointer"
                onClick={() => HandelCustomerSupplierDetailModel()}
                // to={`/${data.PayeeType === 0  ? "manage-suppliers" : data.PayeeType === 1 ? "manage-customers" : "manage-employee"}/${data.Id ? data.Id : data.SupplierId}`} title="Edit"
              >
                <p className="card-Details-Title">
                  {data.FirstName} {data.LastName}{" "}
                  {data.CompanyName != "" ? `(${data.CompanyName})` : ""}
                </p>{" "}
              </div>

              <p className="card-Details"> {data.Email}</p>
              <p className="card-Details">
                {" "}
                Balance:{" "}
                {CurrencySymbols(
                  Number(data.OpenBalance),
                  { CurrencySymbol },
                  FractionDigits
                )}
              </p>
              {/* <p className="card-Details"> Balance: {data.Balance}</p> */}
            </div>

            <div className="w-3 p-2">
              {/* <Link to={`/manage-suppliers/${data.Id ? data.Id : data.SupplierId}`} title="Edit"> */}
              <Link
                to={`/${
                  data.PayeeType === 0
                    ? "manage-suppliers"
                    : data.PayeeType === 1
                    ? "manage-customers"
                    : "manage-employee"
                }/${data.Id ? data.Id : data.SupplierId}`}
                title="Edit"
              >
                <EditOutlinedIcon className="icon-btn-edit" />
              </Link>
              <Link type="button" onClick={() => setCustomerPopup(true)}>
                <DeleteForeverOutlinedIcon className="icon-btn-delete" />
              </Link>
            </div>
          </div>
          <hr />
          <div className="row">
            {/* <div className="col-12"> */}
            <span>
              {showEdit ? (
                <div
                  style={{
                    display: "flex",
                    alignItems: "center",
                    border: "1px solid lightgray",
                    borderRadius: "5px",
                  }}
                >
                  <input
                    id="MailingAddress"
                    name="MailingAddress"
                    placeholder="Billing Address" //Mailing Address
                    className="form-control w-100"
                    style={{ border: "none" }}
                    value={valueOfInput}
                    // defaultValue={data.Address1}
                    // defaultValue={valueOfInput}
                    // onChange={(e) => setValueOfInput(e.target.value)}
                    onChange={(e) => handleAddress(e)}
                  ></input>
                  <div
                    // className="btn btn-outline-primary btn-sm m-1"
                    className="btn-outline-success"
                    onClick={() => AddAddress()}
                  >
                    <i className="fa fa-check" aria-hidden="true"></i>
                  </div>
                  <div
                    // className="btn btn-outline-danger btn-sm m-1"
                    className="btn-outline-danger"
                    onClick={() => setShowEdit(false)}
                  >
                    <i className="fa fa-times" aria-hidden="true"></i>
                  </div>
                </div>
              ) : (
                <>
                  {/* <hr/> */}
                  <div className="accordion-item">
                    <div
                      className="accordion-header"
                      style={{ cursor: "pointer" }}
                      onClick={toggleAccordion}
                    >
                      <button
                        class="accordion-button dropdown-toggle"
                        type="button"
                        data-bs-toggle="collapse"
                        data-bs-target="#collapseOne"
                        aria-expanded="true"
                        aria-controls="collapseOne"
                      >
                        Billing Address
                      </button>
                    </div>
                    {isAccordionOpen && (
                      <div className="accordion">
                        <p>
                          <i
                            className="fa fa-map-marker text-danger fa-1x ml-2 p-2"
                            style={{ fontSize: "16px" }}
                          ></i>
                          {/* {mailingAddress} */}
                          {valueOfInput}
                          &nbsp;&nbsp;
                          <i
                            className="fa fa-pencil text-warning fa-1x ml-2 p-2"
                            style={{ fontSize: "16px", cursor: "pointer" }}
                            onClick={handleClick}
                          ></i>
                        </p>
                      </div>
                    )}
                  </div>
                  {/* <hr/> */}
                </>
              )}
            </span>
            {/* </div> */}
          </div>
        </div>
      </div>
      <CustomerSupplierDetailModel
        id={detailModel?.Id}
        model={detailModel?.Model}
        show={showCustomerModal}
        handleClose={() => {
          setShowCustomerModal(false);
        }}
      />

      <CustomerConfirm
        open={CustomerPopup}
        handleClose={handlecress}
        Module={"Supplier"}
      />
    </>
  );
}

export default ReceivingCard;
